<template>
  <div class="mt-1">
    <b-card>
      <b-overlay :show="loading" rounded="sm" no-fade>
        <b-row class="mb-1">
          <!-- Per Page -->
          <b-col
            cols="12"
            md="7"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-button
              variant="outline-primary"
              class="btn-icon"
              :to="{ path: '/settings' }"
            >
              <i class="fa-solid fa-arrow-left"></i>
              <span class="ml-25">Back</span>
            </b-button>

            <h3 class="ml-1">Companies</h3>
          </b-col>

          <b-col cols="12" md="5">
            <div class="d-flex align-items-center justify-content-end">
              <div class="d-flex align-items-center mr-1">
                <label>Show</label>
                <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries </label>
              </div>

              <b-form-input
                v-model="filter"
                class="d-inline-block mr-1"
                cle
                placeholder="Search..."
              />
              <b-button variant="primary" @click="addCompany()">
                <span class="text-nowrap">Add Company</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-table
          sticky-header
          striped
          hover
          bordered
          ref="refActionListTable"
          :outlined="true"
          :fields="fields"
          :items="filteredCompanies"
          responsive="sm"
          :small="true"
          class="table table-sm table-responsive"
          :filter="filter"
          @filtered="onFiltered"
          :filter-included-fields="filterOn"
          show-empty
          empty-text="No matching records found"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template #cell(title)="data">
            <div class="p-25">
              {{ data.value }}
            </div>
          </template>

          <template #cell(actions)="data">
            <div>
              <b-button
                variant="primary"
                class="mr-25 p-50"
                @click="editCompany(data.item.id)"
              >
                <i class="fa-solid fa-pen-to-square mr-25"></i>
                <span> Edit</span>
              </b-button>

              <b-button
                variant="primary"
                @click="deleteCompany(data.item.id)"
                class="p-50"
              >
                <i class="fa-solid fa-trash mr-25"></i>
                <span> Delete</span>
              </b-button>
            </div>
          </template>
        </b-table>

        <!-- Add pagination below table -->
        <div class="mx-2 mb-1 mt-1">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                {{ dataMeta.of }} entries</span
              >
            </b-col>

            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormRating,
} from "bootstrap-vue";
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import vSelect from "vue-select";

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormRating,
    vSelect,
    ToastificationContent,
  },

  setup() {
    const TASK_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(TASK_APP_STORE_MODULE_NAME))
      store.registerModule(TASK_APP_STORE_MODULE_NAME, settingsStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(TASK_APP_STORE_MODULE_NAME))
        store.unregisterModule(TASK_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      companies: [],
      filter: null,
      filterOn: ["title"],
      loading: true,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      perPage: localStorage.getItem("actionShow") ?? 50,
      currentPage: 1,
      totalRows: 0,

      perPageOptions: [10, 25, 50, 100],
      fields: [
        {
          key: "title",
          label: "Company",
          sortable: true,
          class: "text-left",
          thStyle: "width:80%;color:white!important",
        },
        // { key: 'color', sortable: true, class: 'text-center', thStyle: 'width:20%' },
        {
          key: "actions",
          sortable: false,
          class: "text-center",
          thStyle: "width:20%;color:white!important",
        },
      ],
      tempName: null,
      showAllAdditionals: false,
    };
  },

  watch: {},

  methods: {
    getCompanies() {
      this.loading = true;
      store
        .dispatch("settings/getAllCompanies")
        .then((res) => {
          this.companies = res.data;
          this.totalRows = res.data.length;
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push({ name: "settings" });
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "An error occurred",
              text: "Please try again later or contact support.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },

    editCompany(id) {
      this.$router.push({ name: "settings-company-edit", params: { id: id } });
    },

    deleteCompany(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to delete this company?", {
          size: "sm",
          title: "Confirm Deletion",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.loading = true;
            const company = this.companies.find((met) => met.id === id);

            if (company) {
              store
                .dispatch("settings/deleteCompany", company)
                .then((response) => {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Successful",
                      text: "✔️ Company Delete Successful",
                      icon: "ThumbsUpIcon",
                      variant: "success",
                    },
                  });

                  this.getCompanies();
                })
                .catch((error) => {
                  this.formShow = false;
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "An error occurred",
                      text: "Please try again later or contact support.",
                      icon: "AlertTriangleIcon",
                      variant: "danger",
                    },
                  });
                });
            }
          }
        });
    },

    addCompany() {
      this.$router.push({ name: "settings-company-add" });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },

  created() {
    this.getCompanies();
  },

  computed: {
    dataMeta() {
      return {
        from:
          this.totalRows != 0 ? this.perPage * (this.currentPage - 1) + 1 : 0,
        to:
          this.perPage * (this.currentPage - 1) + Number(this.perPage) <
          this.totalRows
            ? this.perPage * (this.currentPage - 1) + Number(this.perPage)
            : this.totalRows,
        of: this.totalRows,
      };
    },
    filteredCompanies() {
      let filtered = this.companies;

      if (this.filter) {
        const searchTerm = this.filter.toLowerCase();
        filtered = this.companies.filter((item) =>
          item.title.toLowerCase().includes(searchTerm)
        );
      }

      return filtered;
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.table-responsive.b-table-sticky-header {
  max-height: 75vh !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
